import React, { useRef, useEffect } from "react";

const FloatingDotsBackground = () => {
  const canvasRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);

    const dotCount = 120;
    const dots = Array.from({ length: dotCount }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      radius: Math.random() * 1.8 + 0.8,
      speedX: (Math.random() - 0.5) * 0.6,
      amplitude: Math.random() * 30 + 10,
      phase: Math.random() * Math.PI * 2,
      baseY: Math.random() * height,
      pulseSpeed: Math.random() * 0.02 + 0.005,
      opacity: Math.random(),
    }));

    function animate() {
      ctx.clearRect(0, 0, width, height);
      dots.forEach((dot) => {
        dot.phase += 0.01;
        dot.opacity += dot.pulseSpeed;
        if (dot.opacity > 1 || dot.opacity < 0.2) dot.pulseSpeed *= -1;

        dot.x += dot.speedX;
        dot.y = dot.baseY + Math.sin(dot.phase) * dot.amplitude;

        if (dot.x > width) dot.x = 0;
        if (dot.x < 0) dot.x = width;

        ctx.beginPath();
        const gradient = ctx.createRadialGradient(
          dot.x,
          dot.y,
          0,
          dot.x,
          dot.y,
          dot.radius * 3
        );
        gradient.addColorStop(0, `rgba(180, 130, 255, ${dot.opacity})`);
        gradient.addColorStop(1, "rgba(180, 130, 255, 0)");
        ctx.fillStyle = gradient;

        ctx.arc(dot.x, dot.y, dot.radius * 2.5, 0, Math.PI * 2);
        ctx.fill();
      });

      ctx.globalCompositeOperation = "lighter";
      requestAnimationFrame(animate);
    }

    animate();

    const handleResize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
      dots.forEach((dot) => {
        dot.baseY = Math.random() * height;
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: -1,
        background: "black",
        pointerEvents: "none", // ✅ This is the most important line
      }}
    />
  );
};

export default FloatingDotsBackground;
